/**
 * Extracts the comment anchor from a comment permalink.
 *
 * The anchor is the trailing URL fragment that identifies a specific comment,
 * e.g. `discussion_r123456` from
 * `https://github.com/owner/repo/pull/4/files#discussion_r123456`, or
 * `issuecomment-123456`. Returns `'unknown'` when no fragment is present.
 */
export function extractCommentAnchor(permalink: string): string {
  const match = permalink.match(/#([^#\s]+)$/)
  return match?.[1] || 'unknown'
}
